import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

/**
 * Bridge page loaded inside the Zoho Sign embedded-signing iframe
 * (ZohoSignDialog.jsx) after the signer finishes/declines/defers. Zoho
 * navigates the iframe here (configured via redirect_pages when the signing
 * request was created — see zohoSign.service.js); this page's only job is
 * to tell the parent window what happened via postMessage, since the iframe
 * itself has no other way to notify the app that hosts it.
 *
 * Same-origin only: the parent embeds this at window.location.origin, so a
 * same-origin postMessage target is safe and correct here.
 */
const SignatureRedirect = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') || 'unknown';

  useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ source: 'zoho-sign-redirect', status }, window.location.origin);
    }
  }, [status]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={28} />
      <Typography variant="body2" color="text.secondary">
        {status === 'completed' ? 'Signature complete — finishing up…' : 'Closing…'}
      </Typography>
    </Box>
  );
};

export default SignatureRedirect;
